module.exports = __webpack_public_path__ + "img/img3.aae49e99.jpg";